<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getFreightRule,
  add,
  getDetails,
  update,
  del,
  getCheckFreight
} from "@/api/finance/freightrule";

import cTable from "@/base/common/index";

export default {
  inject: ["$page"],
  components: {
    cTable
  },
  props: {
    rows: {
      type: Object
    }
  },
  methods: {
    add() {
      this.$refs["table"]
        .getModal("add")
        .open({ quotation_id: this.rows.id }, function() {
          this.list.push({
            start_time: "",
            end_time: "",
            expense_item_id: "",
            charge_mode: "",
            charge_value: 0,
            charge_currency: "",
            remarks: ""
          });
          this.setTitle(
            this.$t("add") +
              "(" +
              this.$t("freight_fees") +
              this.$t("freightrule") +
              ")"
          );
        });
    }
  },
  data() {
    return {
      methods: {
        list: p => {
          p.freightId = this.config.rows.id;
          return getFreightRule(p);
        },
        add,
        getDetails,
        update,
        del,
        getCheckFreight
      },
      config: {
        slot: "div",
        rows: this.rows,
        rowClassName({ row, rowIndex }) {
          return row.is_expired == 1 ? "custom-gray" : "";
        }
      },
      modals: {
        add: {
          footer: {
            show: () => true
          },
          methods: {
            ok({ row, close }) {
              let data = row;
              let list = JSON.parse(JSON.stringify(this.list));
              list.map(t => {
                t.data_type = 3;
                t.start_time = ~~(new Date(t.start_time).getTime() / 1000);
                t.end_time = ~~(new Date(t.end_time).getTime() / 1000);
              });
              data.other_fee_rules = list;
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 1100,
              draggable: true,
              maskClosable: true,
              styles: { top: "10px" }
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              lower_threshold: [
                { required: true, type: "number", trigger: "blur" }
              ],
              upper_threshold: [
                { required: true, type: "number", trigger: "blur" }
              ],
              first_weight: [
                { required: true, type: "number", trigger: "blur" }
              ],
              additional_weight: [
                { required: true, type: "number", trigger: "blur" }
              ],
              first_weight_price: [
                { required: true, type: "number", trigger: "blur" }
              ],
              additional_weight_price: [
                { required: true, type: "number", trigger: "blur" }
              ],
              extra_charge: [{ required: true, trigger: "blur" }],
              fixed_fee: [{ required: true, trigger: "blur" }],
              discount: [{ required: true, type: "number", trigger: "blur" }]
            }
          },
          grid: [
            { data_type: 24 },
            { first_weight: 12, additional_weight: 12 },
            { lower_threshold: 12, upper_threshold: 12 },
            { first_weight_price: 12, additional_weight_price: 12 },
            { fee_vat_scale: 12, extra_charge: 12 },
            { discount: 12, partition: 12 },
            {
              after_first_weight_price: 12,
              after_additional_weight_price: 12
            },
            { start_day: 12, end_day: 12 },
            { is_calculate: 8, delivery_fail_charge: 8, enable: 8 },
            { fixed_fee: 24 }
          ],
          fields: [
            {
              name: this.$tz("派送,失败"),
              key: "delivery_fail_charge",
              component: "Radio",
              options: [
                { label: this.$tz("收费"), value: "YES" },
                { label: this.$tz("不收费"), value: "NO" }
              ],
              optionsFn: "YES",
              optionsKey: "",
              bind: {
                border: true
              }
            },
            {
              name: this.$tz("是否,地址分区"),
              key: "partition",
              component: "Select",
              placeholder: () => this.$tz("是否,地址分区"),
              options: [
                { label: this.$tz("不分区"), value: 0 },
                { label: this.$tz("T1"), value: 1 },
                { label: this.$tz("T2"), value: 2 },
                { label: this.$tz("T3"), value: 3 },
                { label: this.$tz("T4"), value: 4 }
              ],
              optionsFn: "",
              optionsKey: "",
              default: 0
            },
            {
              name: () => this.$tz("数据,类型"),
              key: "data_type",
              placeholder() {
                return this.$tz("数据,类型");
              },
              component: "Select",
              options: [
                { label: this.$tz("全程"), value: 1 },
                { label: this.$tz("头程"), value: 2 },
                { label: this.$tz("清关"), value: 3 },
                { label: this.$tz("尾程"), value: 4 },
                { label: this.$tz("头程, + ,清关"), value: 6 }
              ],
              default: 1,
              optionsFn: "",
              optionsKey: ""
            },
            {
              key: "enable",
              name: () => this.$t("exlType"),
              placeholder: () => this.$t("select") + this.$t("exlType"),
              component: "Radio",
              bind: {
                border: true
              },
              options: [
                { label: this.$t("enable"), value: 1 },
                { label: this.$t("disable"), value: 2 }
              ],
              default: 1
            },
            {
              key: "first_weight",
              name: () => this.$t("min_weight"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("min_weight"),
              bind: {
                style: "width:100%",
                min: 0
              },
              default: 0
            },
            {
              key: "fee_vat_scale",
              name: () => this.$t("FreightVATRadio"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("FreightVATRadio"),
              bind: {
                formatter: value => `${value}%`,
                parser: value => value.replace("%", ""),
                style: "width:100%",
                min: 0
              },
              default: 0
            },
            {
              key: "additional_weight",
              name: () => this.$t("max_weight"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("max_weight"),
              bind: {
                style: "width:100%",
                min: 0
              },
              default: 0
            },
            {
              key: "lower_threshold",
              name: () => this.$t("lower_threshold"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("lower_threshold"),
              bind: {
                style: "width:100%",
                min: 0
              },
              default: 0
            },
            {
              key: "upper_threshold",
              name: () => this.$t("upper_threshold"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("upper_threshold"),
              bind: {
                style: "width:100%",
                min: 0
              },
              default: 0
            },
            {
              key: "first_weight_price",
              name: () => this.$t("begin_price"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("begin_price"),
              bind: {
                style: "width:100%",
                min: 0
              },
              default: 0,
              methods: {
                "on-change"({ row, value }) {
                  row["after_first_weight_price"] = parseFloat(
                    (value * row["discount"]).toFixed(6)
                  );
                }
              }
            },
            {
              key: "additional_weight_price",
              name: () => this.$t("step_price"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("step_price"),
              bind: {
                style: "width:100%",
                min: 0
              },
              default: 0,
              methods: {
                "on-change"({ row, value }) {
                  row["after_additional_weight_price"] = parseFloat(
                    (value * row["discount"]).toFixed(6)
                  );
                }
              }
            },
            {
              key: "discount",
              name: () => this.$t("discount"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("discount"),
              bind: {
                style: "width:100%",
                min: 0,
                max: 1,
                step: 0.01
              },
              default: 1,
              methods: {
                "on-change"({ row, value }) {
                  if (value < 0.01) {
                    this.$Message["error"]({
                      background: true,
                      content:
                        this.$t("discount") +
                        this.$t("numMin") +
                        this.$t("value") +
                        "0.01",
                      duration: 5
                    });
                    return;
                  }
                  row["after_first_weight_price"] = parseFloat(
                    (value * row["first_weight_price"]).toFixed(6)
                  );
                  row["after_additional_weight_price"] = parseFloat(
                    (value * row["additional_weight_price"]).toFixed(6)
                  );
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "after_first_weight_price",
              name: () =>
                this.$t("discount") + this.$t("after") + this.$t("begin_price"),
              component: "InputNumber",
              placeholder: () =>
                this.$t("discount") + this.$t("after") + this.$t("begin_price"),
              disabled: true,
              bind: {
                style: "width:100%"
              },
              default: 0
            },
            {
              key: "after_additional_weight_price",
              name: () =>
                this.$t("discount") + this.$t("after") + this.$t("step_price"),
              component: "InputNumber",
              placeholder: () =>
                this.$t("discount") + this.$t("after") + this.$t("step_price"),
              disabled: true,
              bind: {
                style: "width:100%"
              },
              default: 0
            },
            {
              key: "extra_charge",
              name: () => this.$t("extra_charge"),
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("extra_charge")
            },
            {
              key: "start_day",
              name: () => this.$t("start") + this.$t("date"),
              component: "DatePicker",
              placeholder: () =>
                this.$t("select") + this.$t("start") + this.$t("date"),
              bind: {
                style: {
                  width: "100%"
                }
              },
              disabledDate: true,
              methods: {
                format({ value }) {
                  return value
                    ? this.format.dateFormat(value, "YYYY-MM-DD")
                    : "";
                }
              }
            },
            {
              key: "end_day",
              name: () => this.$t("end") + this.$t("date"),
              component: "DatePicker",
              placeholder: () =>
                this.$t("select") + this.$t("end") + this.$t("date"),
              bind: {
                style: {
                  width: "100%"
                }
              },
              disabledDate: true,
              methods: {
                format({ value }) {
                  return value
                    ? this.format.dateFormat(value, "YYYY-MM-DD")
                    : "";
                }
              }
            },
            {
              key: "is_calculate",
              name: () => this.$t("is_calculate"),
              component: "Radio",
              bind: {
                border: true
              },
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 }
              ],
              default: 1
            },
            {
              key: "fixed_fee",
              name: () => this.$t("fixed_fee"),
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("fixed_fee"),
              show({ formData }) {
                return formData.is_calculate == 0;
              }
            }
          ],
          table: {
            config: {
              height: 300,
              form: true
            },
            fields: [
              {
                name: this.$tz("费用科目"),
                key: "expense_item_id",
                component: "Select",
                placeholder: () => this.$tz("费用科目"),
                options: [],
                optionsFn: "expenseItem",
                optionsKey: "",
                default: "",
                required: true,
                formType: "number",
                minWidth: 120
              },
              {
                name: this.$tz("计算方式"),
                key: "charge_mode",
                component: "Select",
                placeholder: () => this.$tz("计算方式"),
                options: [],
                optionsFn: "",
                optionsKey: "COLLECTION_METHOD",
                default: "",
                required: true,
                formType: "number",
                minWidth: 120
              },
              {
                name: this.$tz("单价"),
                key: "charge_value",
                component: "InputNumber",
                default: 0,
                required: true,
                bind: {
                  border: true,
                  min: 0,
                  step: 0.01,
                  style: "width:100%"
                },
                default: 0,
                minWidth: 120
              },
              {
                name: this.$tz("币种"),
                key: "charge_currency",
                component: "Select",
                placeholder: () => this.$tz("币种"),
                options: [],
                optionsFn: "getCurrency",
                optionsKey: "",
                default: "",
                required: true,
                minWidth: 120
              },
              {
                name: this.$tz("状态"),
                key: "status",
                component: "Select",
                placeholder: () => this.$tz("状态"),
                options: [],
                optionsFn: "EnableDisableNumber",
                optionsKey: "",
                default: 1,
                clearable: false,
                minWidth: 120,
                formType: "number",
                required: true
              },
              {
                name: () => this.$tz("开始时间"),
                key: "start_time",
                placeholder: () => this.$tz("开始时间"),
                component: "DatePicker",
                bind: {
                  type: "date"
                },
                methods: {
                  format: ({ value }) => new Date(value).getTime()
                },
                required: true,
                minWidth: 150
              },
              {
                name: () => this.$tz("结束时间"),
                key: "end_time",
                placeholder: () => this.$tz("结束时间"),
                component: "DatePicker",
                bind: {
                  type: "date"
                },
                methods: {
                  format: ({ value }) => new Date(value).getTime()
                },
                required: true,
                minWidth: 150
              },
              {
                key: "remarks",
                name: () => this.$tz("备注"),
                placeholder() {
                  return this.$tz("备注");
                },
                component: "Input",
                bind: {
                  type: "textarea",
                  autosize: { minRows: 1, maxRows: 2 }
                },
                minWidth: 150
              },
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "success"
                    }
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "deleteFun",
                    bind: {
                      type: "error"
                    },
                    disabled() {
                      return this.$modal.list.length === 1;
                    }
                  }
                ],
                methods: {
                  add({ rowIndex }) {
                    this.getModal("add").list.splice(rowIndex + 1, 0, {
                      start_time: "",
                      end_time: "",
                      expense_item_id: "",
                      charge_mode: "",
                      charge_value: 0,
                      charge_currency: "",
                      remarks: "",
                      status: ""
                    });
                  },
                  deleteFun({ rowIndex }) {
                    this.getModal("add").list.splice(rowIndex, 1);
                  }
                }
              }
            ]
          }
        },
        validateModal: {
          config: {
            modalBind: {
              width: 800,
              draggable: true,
              maskClosable: true
            }
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("export"),
                key: "export",
                fnName: "export",
                bind: {
                  icon: "md-download",
                  type: "warning",
                  size: "small",
                  style: {
                    marginLeft: "5px"
                  }
                }
              }
            ],
            methods: {
              export() {
                let data = {
                  fields: this.$refs["table"].fields,
                  name:
                    this.$t("freight_fees") +
                    this.$t("freightrule") +
                    this.$t("checkFreight") +
                    this.$t("result"),
                  data: this.$refs["table"].list
                };
                this.$page.exportExc(data);
              }
            }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("charge_params"),
                key: "chargeWeight",
                minWidth: 130
              },
              {
                name: () => this.$t("freight_fees"),
                key: "chargeFees",
                minWidth: 120
              },
              {
                name: () => this.$t("freight_fees") + " VAT",
                key: "fee_vat",
                minWidth: 120
              },
              {
                name: () => this.$t("freight_append"),
                key: "extraCharge",
                minWidth: 100
              },
              {
                name: () => this.$t("actualChargeWeight"),
                key: "actualChargeWeight",
                minWidth: 100
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "data_type",
            placeholder() {
              return this.$tz("数据,类型");
            },
            component: "Select",
            options: [
              { label: this.$tz("全程"), value: 1 },
              { label: this.$tz("头程"), value: 2 },
              { label: this.$tz("清关"), value: 3 },
              { label: this.$tz("尾程"), value: 4 }
            ],
            optionsFn: "",
            optionsKey: ""
          }
        ]
      },
      fields: [
        {
          name: () => this.$tz("数据,类型"),
          key: "data_type_txt",
          minWidth: 110
        },
        {
          name: () => this.$tz("分区"),
          key: "partition",
          minWidth: 110
        },
        {
          name: () => this.$t("min_weight"),
          key: "first_weight",
          minWidth: 100
        },
        {
          name: () => this.$t("max_weight"),
          key: "additional_weight",
          minWidth: 100
        },
        {
          name: () => this.$t("begin_price"),
          key: "first_weight_price",
          minWidth: 100
        },
        {
          name: () => this.$t("step_price"),
          key: "additional_weight_price",
          minWidth: 120
        },
        {
          name: () => this.$t("lower_threshold"),
          key: "lower_threshold",
          minWidth: 130,
          header: {
            spanTitle: true
          }
        },
        {
          name: () => this.$t("upper_threshold"),
          key: "upper_threshold",
          minWidth: 130
        },
        {
          name: () => this.$t("discount"),
          key: "discount",
          minWidth: 130
        },
        {
          name: () =>
            this.$t("discount") + this.$t("after") + this.$t("begin_price"),
          key: "after_first_weight_price",
          minWidth: 130
        },
        {
          name: () =>
            this.$t("discount") + this.$t("after") + this.$t("step_price"),
          key: "after_additional_weight_price",
          minWidth: 130
        },
        {
          name: () => this.$t("FreightVATRadio"),
          key: "fee_vat_scale",
          width: 120,
          methods: {
            render({ value }) {
              return value + "%";
            }
          }
        },
        {
          name: () => this.$t("extra_charge"),
          key: "extra_charge",
          width: 90
        },
        {
          name: () => this.$t("is_calculate"),
          key: "is_calculate",
          width: 125,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("YES") : this.$t("NO");
            }
          }
        },
        {
          name: () => this.$t("fixed_fee"),
          key: "fixed_fee",
          width: 100
        },
        {
          name: () => this.$t("start") + this.$t("date"),
          key: "start_day",
          width: 130
        },
        {
          name: () => this.$t("end") + this.$t("date"),
          key: "end_day",
          width: 130
        },
        {
          name: () => this.$t("exlType"),
          key: "enable",
          width: 130
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("checkFreight"),
              type: "checkFreight",
              fnName: "checkFreight",
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("copy"),
              type: "copy",
              fnName: "copy",
              bind: {
                type: "error"
              }
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete"
            }
          ],

          methods: {
            checkFreight({ row }) {
              this.handleRequestMethods("getCheckFreight", { id: row.id }).then(
                res => {
                  this.getModal("validateModal").open({}, function() {
                    this.list = res.payload;
                    this.setTitle(
                      this.$t("checkFreight") +
                        "(" +
                        this.$t("freight_fees") +
                        this.$t("freightrule") +
                        ")"
                    );
                  });
                }
              );
            },
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").open(res.payload, function() {
                  this.list = res.payload.other_fee_rules || [];
                  if (this.list.length === 0) {
                    this.list.push({
                      start_time: "",
                      end_time: "",
                      expense_item_id: "",
                      charge_mode: "",
                      charge_value: 0,
                      charge_currency: "",
                      remarks: ""
                    });
                  }
                  this.setTitle(
                    this.$t("update") +
                      "(" +
                      this.$t("freight_fees") +
                      this.$t("freightrule") +
                      ")"
                  );
                });
              });
            },
            async copy({ row }) {
              const res = await this.handleRequestMethods("getDetails", row.id);
              let data = res.payload;
              data.id = "";
              this.getModal("add").open(data, function() {
                this.setTitle(this.$t("copy"));
                this.$nextTick(() => {
                  this.disabledConfirm = false;
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>

<style>
.custom-gray td {
  background-color: #ccc !important;
  color: #fff;
}
</style>
